<div class="top-section">
    <h6 class="heading mb-0">{{ ss.t('account_legal') }}</h6>
    <app-svg name="close" role="button" (click)="closeDialog()"></app-svg>
</div>
<div class="">
    <div *ngFor="let item of legalItems()" class="legal-item flex items-center ri-px-4 ri-py-3" role="button"
        (click)="openPolicy(item.type)">
        <p class="text-16-400 color-8 mb-0">{{ item.title }}</p>
    </div>
</div>
